import React from "react";
import "../../../../assets/css/print.css";
import logo from "../../../../assets/img/AgriX_Logoold.png";
 
var QRCode = require("qrcode.react");
 
export default class ComponentToPrint extends React.Component {
  render() {
    const data = this.props.data || [];
 
    return (
      <div style={{ width: "100%" }}>
        <style>
          {`
            @media print {
              html, body {
                margin: 0 !important;
                padding: 0 !important;
                width: 100% !important;
              }
            }
          `}
        </style>
 
        {data.map((d, i) => (
          <div
            key={i}
            style={{ pageBreakBefore: i === 0 ? "auto" : "always", marginTop: "50px" }}
          >
            <div style={{ marginTop: 20, textAlign: "center" }}>
              <img
                src={logo}
                alt="AgriX Logo"
                style={{ height: "150px", width: "300px" }}
              />
            </div>
 
            <div className="col-sm p-3" style={{ marginTop: 20, textAlign: "center" }}>
              <QRCode value={d.tagNo} size={650} />
            </div>
 
            <div style={{ marginTop: 20, textAlign: "center" }}>
              <div
                style={{
                  fontSize: 37,
                  fontWeight: "bold",
                  wordWrap: "break-word",
                  textAlign: "center",
                }}
              >
                {d.tagNo}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}